import { chain, map } from "lodash"
import { assetClassKeyMapIteratee } from "helpers/securities"

const NAME_PATTERN = /^[A-Za-z0-9_\-\s]{3,50}$/

export function computeSecurities(securities) {
  return chain(securities)
    .groupBy("assetClass")
    .mapKeys(assetClassKeyMapIteratee)
    .mapValues((securities) =>
      map(securities, security => {
        switch (security.assetClass) {
          case "equity":
            return {
              ticker: security.ticker,
              mic: security.mic,
              internalId: security.internalId,
            }
          case "fixedIncome":
            return {
              isin: security.id || security.ticker,
            }
          default:
            return security.id || security.ticker
        }
      }),
    )
    .value()
}

export const validateWatchlistName = (name) => {
  return name.match(NAME_PATTERN)
}

export function isSameWatchlist(currentPath, alias, id) {
  const parts = currentPath.split(/\//g)
  if (parts.length < 4) {
    return false
  }

  return parts[2] === "watchlist" && (parts[3] === id || parts[3] === alias)
}
